/**
 * @file hostHooks.ts
 * @description 键盘性能相关宿主钩子：由应用层注入 UI（如 USB2 + 16K 驱动提示弹窗），
 * SDK 不依赖具体组件库。GCOME checkConnect 在连通成功后若判定需提示则 fire-and-forget 调用。
 */

export interface KeyboardPerfHostHooks {
  /**
   * 已安装 16K 驱动但当前为 USB 2.0（或非原装 USB3 线）时提示用户。
   * 非阻塞：宿主可弹窗，SDK 不等待关闭。
   */
  notifyUsb2With16kDriver(): void | Promise<void>
}

let keyboardPerfHostHooks: KeyboardPerfHostHooks | null = null

/** 应用启动时注册；传 null 清除（测试用） */
export function setKeyboardPerfHostHooks(hooks: KeyboardPerfHostHooks | null): void {
  keyboardPerfHostHooks = hooks
}

export function getKeyboardPerfHostHooks(): KeyboardPerfHostHooks | null {
  return keyboardPerfHostHooks
}
